import {ClassName} from '../const';
import {ValidityActions, ValidityShowMode} from './rules';

export default class FormValidator {
  constructor(form) {
    this._form = form;
    this._errors = [];
    this._localErrors = [];
  }

  _validate(value, ruleName, ruleParams, input) {
    const action = ValidityActions[ruleName];

    if (action) {
      const validationResult = action.validate(value, ruleParams, input);

      (typeof validationResult === 'string') && this._errors.push({
        ruleName,
        message: validationResult
      });
    } else {
      window.Sentry.captureException(`Передано несуществующее правило: ${ruleName}`);
      console.error(`Передано несуществующее правило: ${ruleName}`); // eslint-disable-line no-console
    }
  }

  _getCurrentErrors(errors, event) {
    return errors.filter(error => ValidityShowMode[error.ruleName].includes(event));
  }

  _removeErrorsForInput(inputName) {
    this._localErrors = this._localErrors.filter(
      error => error.inputName !== inputName
    );
  }

  check(field, input, ruleParams, event) {
    if (input.disabled || !ruleParams) {
      return true;
    }

    this._errors = [];
    const value = input.value.trim();
    const inputName = input.name;

    Object.keys(ruleParams).forEach((ruleName) => {
      this._validate(value, ruleName, ruleParams, input);
    });

    const currentErrors = this._getCurrentErrors(this._errors, event);

    this._removeErrorsForInput(inputName);

    currentErrors.forEach(error => {
      this._localErrors.push({
        ...error,
        inputName: inputName
      });
    });

    if (input.type === 'checkbox') {
      return this._verifyBox(field, currentErrors);
    }

    return this._verifyField(field, currentErrors);
  }

  _verifyField(field, currentErrors) {
    const error = field.querySelector(`.${ClassName.MESSAGE_ERROR}`);

    if (!currentErrors.length) {
      field.classList.remove(ClassName.FIELD_ERROR);
    } else {
      error.textContent = currentErrors[0].message;
      field.classList.add(ClassName.FIELD_ERROR);
    }

    return !this._errors.length;
  }

  _verifyBox(field, currentErrors) {
    const content = field.querySelector(`.${ClassName.CHECKBOX_CONTENT}`);
    const policy = field.closest(`.${ClassName.POLICY}`)?.querySelector(`.${ClassName.POLICY_ERROR_CONTENT}`);

    if (!currentErrors.length) {
      content.classList.remove(ClassName.CHECKBOX_ERROR);
      policy?.classList.remove(ClassName.POLICY_ERROR);
    } else {
      content.classList.add(ClassName.CHECKBOX_ERROR);

      if (policy) {
        policy.textContent = currentErrors[0].message;
        policy.classList.add(ClassName.POLICY_ERROR);
      }
    }

    return !this._errors.length;
  }

  getCurrentError() {
    return this._localErrors.reduce((acc, error) => {
      const fieldName = error.inputName;

      if (!acc[fieldName]) {
        acc[fieldName] = [];
      }

      if (!acc[fieldName].includes(error.message)) {
        acc[fieldName].push(error.message);
      }

      return acc;
    }, {});
  }

  reset(field) {
    this._errors = [];
    this._removeErrorsForInput(field.name);
    field.classList.remove(ClassName.FIELD_ERROR);
  }
}
